import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { lazy, Suspense } from "react";

// Lazy load components for better performance
const SubscriptionPlans = lazy(() => import("./SubscriptionPlans"));
const SubscriptionSubscribers = lazy(() => import("./SubscriptionSubscribers"));
const SubscriptionTransactions = lazy(() =>
	import("./SubscriptionTransactions")
);
const SubscriptionStatistics = lazy(() => import("./SubscriptionStatistics"));

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`subscription-tabpanel-${index}`}
			aria-labelledby={`subscription-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Suspense fallback={<div>Loading...</div>}>
						{children}
					</Suspense>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `subscription-tab-${index}`,
		"aria-controls": `subscription-tabpanel-${index}`,
	};
}

export default function SubscriptionManagement() {
	const [value, setValue] = React.useState(0);
	const { t } = useTranslation();

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%" }}>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label='subscription management tabs'
				>
					<Tab
						style={{ marginRight: "20px" }}
						label={t("subscription_plans")}
						{...a11yProps(0)}
					/>
					<Tab
						style={{ marginRight: "20px" }}
						label={t("subscription_subscribers")}
						{...a11yProps(1)}
					/>
					<Tab
						style={{ marginRight: "20px" }}
						label={t("subscription_transactions")}
						{...a11yProps(2)}
					/>
					<Tab
						style={{ marginRight: "20px" }}
						label={t("subscription_statistics")}
						{...a11yProps(3)}
					/>
				</Tabs>
			</Box>
			<TabPanel value={value} index={0}>
				<SubscriptionPlans />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<SubscriptionSubscribers />
			</TabPanel>
			<TabPanel value={value} index={2}>
				<SubscriptionTransactions />
			</TabPanel>
			<TabPanel value={value} index={3}>
				<SubscriptionStatistics />
			</TabPanel>
		</Box>
	);
}
